import React from 'react';

const ConstructionPlanSyncModelReferenceHint = () => (
    <div className="model-sync-section__ref-hint">
        Keine Konfigurationsänderung durchgeführt
    </div>
);

export default ConstructionPlanSyncModelReferenceHint;
